import { setPropertiesToRC } from '../utils/setPropertiesToRC.js';
import Native from './components/Native/index.js';
import Empty from './components/Empty/index.js';
import Error from './components/Error/index.js';
import Empty$1 from './components/Network/index.js';

var TiException = setPropertiesToRC(Native, {
  Empty: Empty,
  Error: Error,
  Network: Empty$1
});

export { TiException };
